// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import AppointmentAction from './view'

export default function AppointmentActionFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/AppointmentAction">
      <AppointmentAction {...props}>
        {children}
      </AppointmentAction>
    </Flow>
  )
}
